@if (_businessUnits?.length > 0) {
  <div
    #menu
    class="menu-container"
    [ngClass]="['dropdown', theme, noIconClass]">
    <topo-business-units-display
      [multiSelectionMode]="multiSelectionMode"
      [readonly]="readonly"
      [flowMode]="flowMode"
      [selectedUIds]="_selectedUIds"
      [businessUnits]="_businessUnits"
      (activated)="openMenu()"></topo-business-units-display>
    <div
      #tree
      class="dropdown-menu"
      id="dropdown-menu"
      role="menu">
      <div
        class="tree-close"
        (click)="closeMenu()">
        <i class="icon icon-close-X"></i>
      </div>
      <div>
        <div class="search-container">
          <ng-select
            class="search"
            #ngSelect
            [items]="units$ | async"
            bindLabel="path"
            [multiple]="false"
            [minTermLength]="2"
            [hideSelected]="true"
            [placeholder]="searchPlaceholder"
            [addTag]=""
            [trackByFn]="unitsTrackByFn"
            [loading]="unitsLoading"
            (search)="unitsInput$.next($event.term)"
            [clearable]="true"
            [closeOnSelect]="true"
            [(ngModel)]="selectedUnits"
            (change)="onUnitSearchChanged($event)">
            <ng-template
              ng-label-tmp
              ng-option-tmp
              let-item="item">
              <div
                class="search-selection"
                [title]="item?.path">
                {{ item?.path }}
              </div>
            </ng-template>
          </ng-select>
        </div>
      </div>
      @if (!!treeControl) {
        <mat-tree
          [dataSource]="dataSource"
          [treeControl]="treeControl"
          class="tree-view">
          <mat-nested-tree-node
            *matTreeNodeDef="let node"
            matTreeNodeToggle>
            <li class="mat-tree-node tree-node no-children">
              <div
                class="node-placeholder"
                mat-icon-button></div>
              @if (node.selectable) {
                <div>
                  @if (multiSelectionMode) {
                    <topo-checkbox
                      [checked]="isNodeSelected(node)"
                      [disabled]="node.inactive === true"
                      (checkChanged)="onSelectNode(node)"></topo-checkbox>
                  } @else {
                    <i
                      (click)="onSelectNode(node)"
                      class="icon icon-check_clear single-select-icon"
                      [ngClass]="{ 'selected': isNodeSelected(node) }"></i>
                  }
                </div>
              }
              @if (!node.selectable) {
                <div class="not-selectable"></div>
              }
              <div
                (click)="onSelectNode(node)"
                class="label"
                [ngClass]="{ 'selectable': node.selectable && node.inactive !== true, 'inactive': node.inactive === true }">
                {{ node.unit.name }}
              </div>
            </li>
          </mat-nested-tree-node>
          <mat-nested-tree-node *matTreeNodeDef="let node; when: hasChild">
            <li>
              <div class="mat-tree-node tree-node">
                <div matTreeNodeToggle>
                  <i
                    class="icon expand-collapse-icon"
                    [ngClass]="treeControl.isExpanded(node) ? 'icon-arrow_reveal_down' : 'icon-arrow_reveal_right'"></i>
                </div>
                @if (node.selectable) {
                  <div>
                    @if (multiSelectionMode) {
                      <topo-checkbox
                        [checked]="isNodeSelected(node)"
                        [disabled]="node.inactive === true"
                        (checkChanged)="onSelectNode(node)"></topo-checkbox>
                    }
                    @if (!multiSelectionMode) {
                      <i
                        (click)="onSelectNode(node)"
                        class="icon icon-check_clear single-select-icon"
                        [ngClass]="{ 'selected': isNodeSelected(node) }"></i>
                    }
                  </div>
                }
                @if (!node.selectable) {
                  <div class="not-selectable"></div>
                }
                <div
                  (click)="onSelectNode(node)"
                  class="label"
                  [ngClass]="{ 'selectable': node.selectable && node.inactive !== true }">
                  {{ node.unit.name }}
                </div>
              </div>
              <ul [class.invisible-node]="!treeControl.isExpanded(node)">
                <ng-container matTreeNodeOutlet></ng-container>
              </ul>
            </li>
          </mat-nested-tree-node>
        </mat-tree>
      }
    </div>
  </div>
}
@if (!(_businessUnits?.length > 0)) {
  <div
    fxLayout="row"
    fxLayoutAlign="start center"
    class="no-access">
    {{ 'COMMUNICATIONS.NO-BUSINESS-UNITS-ACCESS' | translate }}
  </div>
}
